/** Zeitraeume der Zeitverteilung (F-28): Tag, Woche (ISO), Monat. */
import {
  addDays, addMonths, addWeeks, differenceInDays, endOfMonth, formatDe, isoWeek, startOfMonth, startOfWeek,
} from '@/lib/datetime';
import type { LocalDate } from '@/domain/types';

export type ZeitraumArt = 'tag' | 'woche' | 'monat';

export const ZEITRAUM_ARTEN: { key: ZeitraumArt; label: string }[] = [
  { key: 'tag', label: 'Tag' },
  { key: 'woche', label: 'Woche' },
  { key: 'monat', label: 'Monat' },
];

/** Erster Tag des Zeitraums, in dem `tag` liegt. */
export function zeitraumStart(art: ZeitraumArt, tag: LocalDate): LocalDate {
  return art === 'tag' ? tag : art === 'woche' ? startOfWeek(tag) : startOfMonth(tag);
}

/** Alle Tage des Zeitraums, in dem `tag` liegt. */
export function zeitraumTage(art: ZeitraumArt, tag: LocalDate): LocalDate[] {
  const von = zeitraumStart(art, tag);
  const bis = art === 'tag' ? von : art === 'woche' ? addDays(von, 6) : endOfMonth(von);
  return Array.from({ length: differenceInDays(von, bis) + 1 }, (_, i) => addDays(von, i));
}

export function zeitraumVerschieben(art: ZeitraumArt, tag: LocalDate, schritt: number): LocalDate {
  const von = zeitraumStart(art, tag);
  return art === 'tag' ? addDays(von, schritt) : art === 'woche' ? addWeeks(von, schritt) : addMonths(von, schritt);
}

export function zeitraumTitel(art: ZeitraumArt, tag: LocalDate): string {
  const tage = zeitraumTage(art, tag);
  if (art === 'tag') return formatDe(tag, 'EEEE, dd.MM.yyyy');
  if (art === 'woche') return `KW ${isoWeek(tage[0]!)} · ${formatDe(tage[0]!, 'dd.MM.')}–${formatDe(tage[6]!, 'dd.MM.yyyy')}`;
  return formatDe(tage[0]!, 'MMMM yyyy');
}

/** Wie die Vorperiode heisst - fuer den Vergleich (Vorschlag). */
export const VORPERIODE: Record<ZeitraumArt, string> = { tag: 'gestern', woche: 'Vorwoche', monat: 'Vormonat' };
